module.exports = __webpack_public_path__ + "static/media/search.b2feb1c7.svg";